export const PRODUCT_TABS = {
    categories: 'categories',
    search: 'search',
    dashboard: 'dashboard',
    fees: 'fees',
    merchandize: 'merchandize',
    specialService: 'specialService',
    transport: 'transport'
}
